import { getQuery } from 'utilities/query';

export default class CompanyService {
  constructor($http) {
    'ngInject';

    this.$http = $http;
  }

  getCompany(id) {
    return this.$http.get(`/api/member/${id}`);
  }

  update(company) {
    return this.$http.put(`/api/member/${company.MemberId}`, company);
  }

  add(company) {
    return this.$http.post('/api/member', company);
  }

  updateCompliance(company) {
    return this.$http.put(`/api/member/${company.MemberId}/compliance`, company);
  }

  getDefaultQuery() {
    return {
      ...getQuery(),
      orderBy: 'MemberName',
      direction: 'asc'
    };
  }

  /* eslint-disable max-len */
  search(query) {
    return this.$http.get('/odata/MemberOData', {
      params: {
        $select: 'MemberId, MemberName, IsActive, IsLogOut, IsRequireMonthlyCompliance, IsNascAudited, DateBecameAudited',
        $top: query.take,
        ...query.page && { $skip: query.calculateSkip() },
        $orderby: `${query.orderBy} ${query.direction}`,
        ...query.filter && { $filter: query.filter.toString() },
        $count: true
      }
    });
  }
/* eslint-enable max-len */
}



// WEBPACK FOOTER //
// ./services/company.service.js